import {
    type NavigateOptions,
    type To,
    useLocation,
    useNavigate,
} from "react-router";

const useNavigateWithParams = (): ((
    path: To | -1,
    options?: NavigateOptions,
) => void) => {
    const navigate = useNavigate();
    const { search } = useLocation();

    const navigateWithParams = (
        path: To | -1,
        options: NavigateOptions = {},
    ): void => {
        if (typeof path !== "string") {
            navigate(path as To, options);
            return;
        }

        navigate(`${path}${search}`, options);
    };
    return navigateWithParams;
};
export { useNavigateWithParams };
